import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    top: 135,
  },
  sticky: {
    position: 'sticky',
    zIndex: 2,
  },
}));
